<div style="display: block; padding-top: 20px">
  <div style="text-align: center">
    <p>Expedientes tramitados durante el año actual</p>
  </div>

  <canvas baseChart
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [options]="lineChartOptions"
          [colors]="lineChartColors"
          [legend]="lineChartLegend"
          [chartType]="lineChartType"

  ></canvas>

</div>

